// extracted by mini-css-extract-plugin
module.exports = {"passenger":"passenger-yQM4Y","active":"active-3F9Kx","checkbox":"checkbox-qwG3t","label":"label-2Xy5N"};